import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index$1 = createBrowserOnlyLazyComponent(()=>import('./component-6392f9c3.js'/* webpackChunkName: "dbh.onetapsignin.button" */));

var index = createBrowserOnlyLazyComponent(()=>import('./component-b6282f3a.js'/* webpackChunkName: "dbh.onetapsignin" */));

export { index$1 as LazyLoadedOneTapSignInButton, index as default };
